import EmployeeEmploymentShiftComponents from "../components/EmployeeEmploymentShift";
import useEmployeeEmploymentShift from "../hooks/useEmployeeEmploymentShift";

function EmployeeEmploymentShift() {
  const employeeEmploymentShiftProps = useEmployeeEmploymentShift();
  return (
    <EmployeeEmploymentShiftComponents {...employeeEmploymentShiftProps} />
  );
}

export default EmployeeEmploymentShift;
